import { Injectable } from '@angular/core';
import { Store } from '@examdojo/state';
import { createStore, withProps } from '@ngneat/elf';
import { UserReviewModeBindingsHttpModel } from './review-permissions.model';

export interface ReviewPermissionsState {
  reviewPermissions: UserReviewModeBindingsHttpModel[];
}

@Injectable({ providedIn: 'root' })
export class ReviewPermissionsStore extends Store<ReviewPermissionsState> {
  constructor() {
    super(createStore({ name: 'review_permissions' }, withProps<ReviewPermissionsState>({ reviewPermissions: [] })));
  }
}
